import { Stack } from "@similarweb/ui-components/foundations";

import { AlertsErrorBoundary } from "../AlertsErrorBoundary";
import { NewsAlertsFilters } from "../news-alerts/filters/NewsAlertsFilters";
import { NewsAlertsFeed } from "../news-alerts/NewsAlertsFeed";
import { NewsAlertsMetrics } from "../news-alerts/NewsAlertsMetrics";
import type { AlertViewMode } from "../tabs/viewModeConfig";

type NewsPanelProps = {
    viewMode: AlertViewMode;
};

export const NewsPanel = ({ viewMode }: NewsPanelProps) => (
    <Stack
        gap="32px"
        flexGrow={1}
    >
        <NewsAlertsFilters viewMode={viewMode} />
        <AlertsErrorBoundary
            alertType="news"
            viewMode={viewMode}
        >
            {viewMode === "feed" ? <NewsAlertsFeed /> : <NewsAlertsMetrics />}
        </AlertsErrorBoundary>
    </Stack>
);
